/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tea_Purchase_Processed_At_FutureInputs */

const vi_tea_purchase_processed_at_future = /** @type {(inputs: Tea_Purchase_Processed_At_FutureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ngày thu hoạch không được sau hôm nay`)
};

/**

* @param {Tea_Purchase_Processed_At_FutureInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const tea_purchase_processed_at_future = /** @type {((inputs?: Tea_Purchase_Processed_At_FutureInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tea_Purchase_Processed_At_FutureInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_tea_purchase_processed_at_future(inputs)
});